import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { User } from '../../models/user';
import { Language } from '../../models/language';
import { UserProfile } from '../../models/user-profile';

export const USER_ACTIONS = {
  LOGIN_USER: 'LOGIN_USER',
  LOGOUT_USER: 'LOGOUT_USER',
  CHANGE_LANGUAGE: 'CHANGE_LANGUAGE',
  UPDATE_PROFILE: 'UPDATE_PROFILE'
};

@Injectable()
export class UserActions {

  constructor(private store: Store<User>) { }

  loginUser(user: User) {
    this.store.dispatch({ type: USER_ACTIONS.LOGIN_USER, payload: user });
  }

  logoutUser() {
    this.store.dispatch({ type: USER_ACTIONS.LOGOUT_USER });
  }

  changeLanguage(language: Language) {
    this.store.dispatch({ type: USER_ACTIONS.CHANGE_LANGUAGE, payload: language });
  }

  updateProfile(profile: UserProfile) {
    this.store.dispatch({ type: USER_ACTIONS.UPDATE_PROFILE, payload: profile });
  }
}


// WEBPACK FOOTER //
// ./src/app/store/actions/user.actions.ts